import queryClient from "single-spa/react-app/query-client";

import { createAdvancedSearchQueryClient } from "./factory";
import type { IAdvancedSearchQueryClient } from "./types";

export const advancedSearchQueryClient: IAdvancedSearchQueryClient =
    createAdvancedSearchQueryClient({ queryClient });
